// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchBar_search__3W5wc","searchContainer":"SearchBar_searchContainer__1ebFL"};